import axios from 'axios';

import buildPaginationQueryOpts from '@/shared/sort/sorts';

import { IOrganization } from '@/shared/model/organization.model';

const baseApiUrl = 'api/organizations';
const baseSearchApiUrl = 'api/_search/organizations?query=';
const baseURL = 'api/organization';

export default class OrganizationService {
  public search(query, paginationQuery): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(`${baseSearchApiUrl}${query}&${buildPaginationQueryOpts(paginationQuery)}`)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public find(id: number): Promise<IOrganization> {
    return new Promise<IOrganization>((resolve, reject) => {
      axios
        .get(`${baseApiUrl}/${id}`)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public retrieve(paginationQuery?: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(baseApiUrl + `?${buildPaginationQueryOpts(paginationQuery)}`)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public delete(id: number): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .delete(`${baseApiUrl}/${id}`)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public create(entity: IOrganization): Promise<IOrganization> {
    return new Promise<IOrganization>((resolve, reject) => {
      axios
        .post(`${baseApiUrl}`, entity)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public update(entity: IOrganization): Promise<IOrganization> {
    return new Promise<IOrganization>((resolve, reject) => {
      axios
        .put(`${baseApiUrl}/${entity.id}`, entity)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public partialUpdate(entity: IOrganization): Promise<IOrganization> {
    return new Promise<IOrganization>((resolve, reject) => {
      axios
        .patch(`${baseApiUrl}/${entity.id}`, entity)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public switchOrganization(id: number): Promise<IOrganization> {
    return new Promise<IOrganization>((resolve, reject) => {
      axios
        .get(`${baseURL}/switch/${id}`)
        .then(res => {
          sessionStorage.setItem('CurrentOrganization', JSON.stringify (res.data));
          resolve(res.data)
        })
        .catch(err => {
          reject(err);
        });
    });
  }


  public checkOrganizationNameExists(organizationName:string): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(`${baseApiUrl}/check-name-availability/${organizationName}`)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public retriveUsers(organizationId:number): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(`${baseURL}/users/${organizationId}`) 
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

}
